<div
  class="futures-toggle-button"
  role="group"
  *transloco="let t; read: 'app.futures.futuresToggleButton'"
  [attr.aria-label]="t('groupLabel')"
>
  <button
    type="button"
    class="futures-toggle-button__button"
    [class.futures-toggle-button__button--active]="!isFuturesRoute()"
    [disabled]="!isFuturesRoute()"
    [attr.aria-pressed]="!isFuturesRoute()"
    (click)="toggleFuturesVersionOfPage()"
  >
    {{ t("cfd") }}
  </button>
  <div class="futures-toggle-button__separator" aria-hidden="true"></div>
  <button
    type="button"
    class="futures-toggle-button__button"
    [class.futures-toggle-button__button--active]="isFuturesRoute()"
    [disabled]="isFuturesRoute()"
    [attr.aria-pressed]="isFuturesRoute()"
    (click)="toggleFuturesVersionOfPage()"
  >
    {{ t("futures") }}

    <span class="futures-toggle-button__new-badge">{{ t("new") }}</span>
  </button>
</div>
